import React, { useEffect } from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  ImageField,
  NumberInput,
  Filter,
  FileField,
  FileInput,
  TextField,
  TextInput,
  EditButton,
  ArrayInput,
  SelectInput,
  SimpleFormIterator,
  FunctionField,
  ReferenceField,
  DateField,
  ReferenceInput,
  AutocompleteInput,
  required,
  BooleanInput,
  BooleanField,
  Show,
  TabbedShowLayout,
  Tab,
  ReferenceManyField,
  ShowButton,
  Button,
  NumberField,
  TopToolbar,
  useShowController,
  Loading,
  useNotify,
  useRefresh,
  useDataProvider,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { Switch } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import VideoJS from '../VideoJS';
import VideoDownloadButton from '../VideoDownloadButton';
import CourseStatusHistory from './CourseStatusHistory';

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Хичээлийн нэр" source="title" alwaysOn />
    <TextInput label="Шошго" source="tags" alwaysOn />
</Filter>
);

const getStatus = (status) => {
  if (status === 'draft') {
    return "драфтласан";
  }
  if (status === 'comming_soon') {
    return "тун удахгүй";
  }
  return "нийтлэсэн";
}

export const CourseList = props => {
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const handlePinnedToggle = async (record, checked) => {
    let newTags = Array.isArray(record.tags) ? [...record.tags] : [];
    if (checked) {
      if (!newTags.includes('pinned')) newTags.push('pinned');
    } else {
      newTags = newTags.filter(tag => tag !== 'pinned');
    }
    try {
      await dataProvider.update('skills/courses', {
        id: record.id,
        data: { ...record, tags: newTags },
        previousData: record,
      });
      notify('Санал болгох төлөв шинэчлэгдлээ', { type: 'success' });
      refresh();
    } catch (e) {
      notify('Алдаа гарлаа', { type: 'error' });
    }
  };

  return (
    <List {...props} filters={<TextFilter/>}>
      <Datagrid optimized>
        <TextField label="ID" source="id" />
        <ReferenceField source="creatorId" reference="skills/creators">
          <TextField label="Creator" source="firstName" />
        </ReferenceField>
        <ReferenceField source="categoryId" reference="skills/categories">
          <TextField label="Ангилал" source="name" />
        </ReferenceField>
        <TextField label="Гарчиг" source="title" />
        <FunctionField label="Статус" render={record => getStatus(record.status)} />
        <TextField label="Контент түвшин" source="requiredTier" />
        <BooleanField label="Univision" source="isUnivision" />
        <NumberField label="Төлбөр" source="price" />
        <DateField label="Үүсгэсэн огноо" source="createdAt" />
        <FunctionField label="санал болгох" render={record => (
          <Switch
            checked={record.tags && record.tags.includes('pinned')}
            onChange={e => handlePinnedToggle(record, e.target.checked)}
            color="primary"
            inputProps={{ 'aria-label': 'санал болгох' }}
          />
        )} />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const CourseTitle = ({ record }) => {
  return <span>Хичээл: {record ? `"${record.title}"` : ''}</span>;
};

export const CourseEdit = props => {
  

  

  

  return (
    <Edit title={<CourseTitle />} {...props}>
      <SimpleForm>
        
        <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={false} />
        <TextInput disabled source="id" />
        <ReferenceInput label="Creator" source="creatorId" reference="skills/creators" validate={[required()]} perPage={500}>
          <AutocompleteInput optionText="firstName" />
        </ReferenceInput>
        <ReferenceInput label="Category" source="categoryId" reference="skills/categories" validate={[required()]}>
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput fullWidth label="Гарчиг" source="title" validate={[required()]} />
        <TextInput multiline fullWidth rows={5} label="Танилцуулга" source="description" />
        <SelectInput
          label="Контент түвшин"
          source="requiredTier"
          validate={[required()]}
          choices={[
            { id: 'FREE', name: 'Free' },
            { id: 'BASIC', name: 'Basic' },
            { id: 'PREMIUM', name: 'Premium' },
            { id: 'BOX', name: 'Box' },
          ]}
        />
        <BooleanInput label="Univision" source="isUnivision" />
        <SelectInput
          label="Univision Content Type"
          source="univisionContentType"
          choices={[
            { id: 'Original', name: 'Original' },
            { id: 'Skills', name: 'Skills' },
            { id: 'Foreign', name: 'Foreign' },
            { id: 'Lingo', name: 'Lingo' },
          ]}
        />
        <ImageField source="thumbnailImage" label="thumbnailImage" />
        <FileInput source="file" label="Зураг" accept="image/*">
          <FileField title="image" />
        </FileInput>
        <TextInput fullWidth label="materialLink" source="materialLink" />
        <FileInput source="documentFile" label="Хичээлийн материал" accept="application/pdf, image/*, application/zip, application/octet-stream">
          <FileField title="title" />
        </FileInput>
        <TextInput label="Хугацаа" source="totalDuration" validate={[required()]} />
        <NumberInput label="Төлбөр" source="price" validate={[required()]} />
        <NumberInput label="Хямдарсан үнэ" source="saledPrice" />
        <ArrayInput
          fullWidth
          label="Юу юунаас бүрдэж байгаа вэ?"
          source="includes">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput fullWidth label="Хүлээж буй зүйлс" source="outcomes">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput label="Шаардлагаууд" source="requirements">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput label="Шошго" source="tags">
          <SimpleFormIterator>
            <TextInput fullWidth label="утга" />
          </SimpleFormIterator>
        </ArrayInput>
        <SelectInput
          label="статус"
          source="status"
          defaultValue="draft"
          validate={[required()]}
          choices={[
            { id: 'draft', name: 'драфтласан' },
            { id: 'published', name: 'нийтлэсэн' },
            { id: 'comming_soon', name: 'тун удахгүй' },
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};

export const CourseCreate = props => {
  return (
    <Create {...props}>
      <SimpleForm>
        
        <BooleanInput label="Notification явуулах уу?" source="shouldSendNotification" initialValue={true} />
        <ReferenceInput label="Creator" source="creatorId" reference="skills/creators" validate={[required()]} perPage={500}>
          <AutocompleteInput optionText="firstName" />
        </ReferenceInput>
        <ReferenceInput label="Category" source="categoryId" reference="skills/categories" validate={[required()]}>
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput fullWidth label="Гарчиг" source="title" validate={[required()]} />
        <TextInput multiline fullWidth rows={5} label="Танилцуулга" source="description" />
        <SelectInput
          label="Контент түвшин"
          source="requiredTier"
          validate={[required()]}
          choices={[
            { id: 'FREE', name: 'Free' },
            { id: 'BASIC', name: 'Basic' },
            { id: 'PREMIUM', name: 'Premium' },
            { id: 'BOX', name: 'Box' },
          ]}
        />
        <BooleanInput label="Univision" source="isUnivision" />
        <SelectInput
          label="Univision Content Type"
          source="univisionContentType"
          choices={[
            { id: 'Original', name: 'Original' },
            { id: 'Skills', name: 'Skills' },
            { id: 'Foreign', name: 'Foreign' },
            { id: 'Lingo', name: 'Lingo' },
          ]}
        />
        <FileInput source="file" label="Зураг" accept="image/*">
          <FileField title="image" />
        </FileInput>
        <FileInput source="documentFile" label="Хичээлийн материал" accept="application/pdf, image/*, application/zip, application/octet-stream">
          <FileField title="title" />
        </FileInput>
        <TextInput label="Хугацаа" source="totalDuration" validate={[required()]} />
        <NumberInput label="Төлбөр" source="price" validate={[required()]} />
        <NumberInput label="Хямдарсан үнэ" source="saledPrice" />
        <ArrayInput
          fullWidth
          label="Юу юунаас бүрдэж байгаа вэ?"
          source="includes">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput fullWidth label="Хүлээж буй зүйлс" source="outcomes">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput fullWidth label="Шаардлагууд" source="requirements">
          <SimpleFormIterator>
            <TextInput fullWidth label="Сэдэв" />
          </SimpleFormIterator>
        </ArrayInput>
        <SelectInput
          label="статус"
          source="status"
          defaultValue="draft"
          validate={[required()]}
          choices={[
            { id: 'published', name: 'нийтлэсэн' },
            { id: 'draft', name: 'драфтласан' },
            { id: 'comming_soon', name: 'тун удахгүй' },
          ]}
        />
      </SimpleForm>
    </Create>
  );
};

const extractVideoId = (url) => {
  if (!url) return null;
  const videoId = url.split('/').reverse()[1];
  return videoId;
}

const getVideoStatus = (url) => {
  if (url === null) {
    return "Processing";
  }
  return "Finished";
}

const EmptyVideosContent = () => (
  <div style={{ textAlign: 'center', margin: '1em' }}>
    <p>Энэ хичээлд одоогоор видео байхгүй байна.</p>
  </div>
);

export const CourseShow = props => {
  const { record, loading } = useShowController(props);
  
  useEffect(() => {
    if (record) {
      console.log('Course Show Detail Record:', record);
    }
  }, [record]);
  
  const AddVideoButton = ({ record }) => (
    <TopToolbar>
      <Button
        component={Link}
        to={{
          pathname: '/skills/videos/create',
          search: `?courseId=${record?.id}`,
        }}
        label="Видео нэмэх"
      >
        <AddIcon />
      </Button>
    </TopToolbar>
  );

  const ShowActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      <EditButton basePath={basePath} record={data} />
    </TopToolbar>
  );
  
  if (loading) return <Loading />;
  
  return (
    <Show {...props} actions={<ShowActions />}>
      <TabbedShowLayout>
        <Tab label="Хичээлийн мэдээлэл">
          <TextField label="ID" source="id" />
          <ReferenceField source="creatorId" reference="skills/creators">
            <TextField label="Creator" source="firstName" />
          </ReferenceField>
          <ReferenceField source="categoryId" reference="skills/categories">
            <TextField label="Category" source="name" />
          </ReferenceField>
          <TextField label="Гарчиг" source="title" />
          <TextField label="Контент түвшин" source="requiredTier" />
          <TextField label="Танилцуулга" source="description" />
          <BooleanField label="Univision" source="isUnivision" />
          <TextField label="Univision Content Type" source="univisionContentType" />
          <NumberField label="Төлбөр" source="price" />
          <NumberField label="Хямдарсан үнэ" source="saledPrice" />
          <TextField label="Хугацаа" source="totalDuration" />
          <DateField label="Үүсгэсэн огноо" source="createdAt" />
          <FunctionField label="Статус" render={record => getStatus(record.status)} />
          <ImageField source="thumbnailImage" label="thumbnailImage" />
          <FunctionField label="санал болгох" render={record => (record.tags && record.tags.includes('pinned') ? '✓' : '-')} />
          <CourseStatusHistory courseId={props.id} />
        </Tab>
        
        <Tab label="Видеонууд / Хичээлүүд" path="videos">
          <AddVideoButton record={props.record} />
          <ReferenceManyField
            reference="skills/videos"
            target="courseId"
            sort={{ field: 'order', order: 'ASC' }}
            perPage={100}
            pagination={false}
            addLabel={false}
            empty={<EmptyVideosContent />}
          >
            <Datagrid>
              <TextField label="ID" source="id" />
              <FunctionField 
                label="Нэр" 
                render={record => (
                  <Link to={`/skills/videos/${record.id}/show`} style={{ textDecoration: 'none', color: '#1976d2' }}>
                    {record.title}
                  </Link>
                )}
              />
              <TextField label="Дараалал" source="order" />
              <FunctionField label="Статус" render={record => getVideoStatus(record.url)} />
              <BooleanField label="Үнэгүй үзэх" source="isPreview" />
              <FunctionField label="Видео" render={record => 
                (record?.videoId || extractVideoId(record?.url)) ? (
                  <VideoJS videoId={(record?.videoId || extractVideoId(record?.url))} />
                ) : (
                  <>Видео байхгүй</>
                )
              } />
              <FunctionField label="Татаж авах" render={
                record => (record?.videoId || extractVideoId(record?.url)) ? (
                  <VideoDownloadButton videoId={(record?.videoId || extractVideoId(record?.url))} />
                ) : (
                  <>Видео байхгүй</>
                )
              } />
              <EditButton basePath="/skills/videos" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
